import { useEffect } from "react";
import { useLocation as useRouterLocation } from "react-router-dom";

const useSyncPageWithRoute = ({ allNavItems, currentPage, setCurrentPage }) => {
    const routerLocation = useRouterLocation();

    useEffect(() => {
        // Sync currentPage with URL path
        const pathParts = routerLocation.pathname.split('/').filter(Boolean);
        const lastPart = pathParts[pathParts.length - 1];

        if (lastPart && allNavItems && allNavItems.length > 0) {
            const matchedNavItem = allNavItems.find(
                (item) => item.page.toLowerCase() === lastPart.toLowerCase()
            );

            if (matchedNavItem) {
                if (currentPage !== matchedNavItem.page) {
                    setCurrentPage(matchedNavItem.page);
                }
            } else {
                // Fallback to dashboard if path is unhandled or root
                if (currentPage !== 'dashboard') {
                    setCurrentPage('dashboard');
                }
            }
        } else if (allNavItems && allNavItems.length > 0) {
            if (currentPage !== 'dashboard') {
                setCurrentPage('dashboard');
            }
        }
    }, [routerLocation.pathname, allNavItems, currentPage]);
};

export default useSyncPageWithRoute;